// extracted by mini-css-extract-plugin
export default {"container":"ProcedureList_container__9HW4U","header":"ProcedureList_header__R4z1m"};